import { Container, Sprite } from 'pixi.js';
import { getGameSize, IGameSizeInfo } from '../../Config/Levels';
import { LoadingTxt } from './LoadingTxt';

export class LoadingScreen extends Container {
    private bg: Sprite;
    private jong: Sprite;
    private loadTxt: LoadingTxt;

    constructor() {
        super();

        const gameSize = getGameSize();
        const bg = new Sprite(PIXI.utils.TextureCache['loading/win-bg']);
        bg.x = gameSize.gameWidth * 0.5 - bg.width * 0.5;
        bg.y = getGameSize().gameHeight * 0.5 - bg.height * 0.5;
        this.bg = bg;

        this.jong = new Sprite(PIXI.utils.TextureCache['loading/spin-ferret']);
        this.jong.anchor.set(0.5);
        this.jong.scale.set(1.5);
        this.jong.x = gameSize.gameWidth * 0.5;
        this.jong.y = gameSize.gameHeight * 0.5;

        this.loadTxt = new LoadingTxt();
        this.loadTxt.x = this.jong.x;
        this.loadTxt.y = this.jong.y + gameSize.gameHeight * 0.2;

        //@ts-ignore
        this.addChild(this.bg, this.jong, this.loadTxt);
    }

    public resize(sizeInfo: IGameSizeInfo) {
        if (!this.bg) {
            return;
        }
        this.jong.x = sizeInfo.gameWidth * 0.5;
        this.jong.y = sizeInfo.gameHeight * 0.5;

        this.loadTxt.x = this.jong.x;
        this.loadTxt.y = this.jong.y + sizeInfo.gameHeight * 0.2;

        this.bg.scale.set(1);

        let bScale = sizeInfo.gameWidth / this.bg.width;
        if (this.bg.height * bScale < sizeInfo.gameHeight) {
            bScale = sizeInfo.gameHeight / this.bg.height;
        }

        this.bg.scale.set(bScale);

        this.bg.x = sizeInfo.gameWidth * 0.5 - this.bg.width * 0.5;
        this.bg.y = sizeInfo.gameHeight * 0.5 - this.bg.height * 0.5;
    }

    public update(loadstr: string) {
        if (this.jong) {
            this.jong.rotation -= 0.1;
        }

        if (this.loadTxt) {
            this.loadTxt.update(loadstr);
        }
    }
}
